export default __webpack_public_path__ + "4d657f2ac0e6c9a7ca068cdb2e02fe02.png";